import General from './General';

const Layout = ({ layout, ...props }) => {
  switch (layout) {
    case 'general':
    default:
      return <General {...props} />;
  }
};

export default Layout;
